<template>
  <!-- Footer Start -->
  <div id="footer" class="container-fluid bg-dark text-white-50 footer pt-5">
    <div class="container py-5">
      <div class="row g-5">
        <div class="col-md-6 col-lg-2 wow fadeIn" data-wow-delay="0.1s">
          <a href="index.html" class="d-inline-block mb-3">
            <h1 class="text-white">
              <!-- AI<span class="text-primary">.</span>Tech -->
              {{ info.mainTitle }}
            </h1>
          </a>
          <p class="mb-0">{{ info.mainDescription }}</p>
        </div>
        <div class="col-md-6 col-lg-2 wow fadeIn" data-wow-delay="0.5s">
          <h5 class="text-white mb-4">{{ $t("home.us") }}</h5>
          <span
            class="btn btn-link"
            v-for="(item, index) in aboutList"
            :key="index"
            @click="goPage(1, item)"
            >{{ item.typeName }}</span
          >
        </div>
        <div class="col-md-6 col-lg-2 wow fadeIn" data-wow-delay="0.5s">
          <h5 class="text-white mb-4">{{ $t("home.sulotion") }}</h5>
          <span
            class="btn btn-link"
            v-for="(item, index) in typeList"
            :key="index"
            @click="goPage(2, item)"
            >{{ item.typeName }}</span
          >
        </div>
        <div class="col-md-6 col-lg-2 wow fadeIn" data-wow-delay="0.7s">
          <h5 class="text-white mb-4">{{ $t("home.product") }}</h5>
          <span
            class="btn btn-link"
            v-for="(item, index) in procductList"
            :key="index"
            @click="goPage(3, item)"
            >{{ item.typeName }}</span
          >
        </div>
        <div class="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="0.7s">
          <!-- <h5 class="text-white mb-4">{{ $t("home.product") }}</h5>
          <span
            class="btn btn-link"
            v-for="(item, index) in procductList"
            :key="index"
            @click="goPage(3, item)"
            >{{ item.typeName }}</span
          > -->
          <div class="row">
            <div class="col-md-6 col-lg-12 wow fadeIn d-flex justify-content-around">
              <div class="box_img" v-for="(ite,inde) in erCodes" :key="ite.iconUrl">
                <div class="img_">
                <!-- ../assets/img/ercode.png -->
                  <img class="img-fluid w-100 h-100" :src="ite.iconUrl" />
                </div>
                <span class="text">{{ite.title}}</span>
              </div>
              <!-- <div class="box_img">
                <div class="img_">
                  <img class="img-fluid w-100 h-100" src="../assets/img/ercode.png" />
                </div>
                <span class="text">百家号</span>
              </div>
              <div class="box_img">
                <div class="img_">
                  <img class="img-fluid w-100 h-100" src="../assets/img/ercode.png" />
                </div>
                <span class="text">百家号</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container wow fadeIn" data-wow-delay="0.1s">
      <div class="copyright">
        <div class="row">
          <div class="col-md-12 text-center text-md-center mb-3 mb-md-0">
            <!-- &copy; <a class="border-bottom" href="#">Your Site Name</a> -->
            <!-- © 深圳市航鸿达科技有限公司 版权所有 2016-2021 网站地图 -->
            <div style="width: 100%" v-html="info.remark"></div>
          </div>
          <!-- <div class="col-md-6 text-center text-md-end">
                      <div class="footer-menu">
                          <a href="">Home</a>
                          <a href="">Cookies</a>
                          <a href="">Help</a>
                          <a href="">FAQs</a>
                      </div>
                  </div> -->
        </div>
      </div>
    </div>
  </div>
  <!-- Footer End -->
</template>
<script>
import { productType } from "@/api/modules/product";
import { solutionType } from "@/api/modules/solution";
import { aboutType } from "@/api/modules/about";
import { homePage } from "@/api/modules/home";
export default {
  name: "Footer",
  data() {
    return {
      procductList: [],
      typeList: [],
      aboutList: [],
      info: {},
      contentstr: "",
      erCodes:[]
    };
  },
  mounted() {
    this.getProductType();
    this.getSolutionType();
    this.getAboutType();
    this.getList();
  },
  methods: {
    // 获取产品分类
    getProductType() {
      productType(this.$store.getters.lang).then((res) => {
        if (res.returnCode == 200) {
          this.procductList = res.data;
        }
      });
    },
    // 获取解决方案分类
    getSolutionType() {
      solutionType(this.$store.getters.lang).then((res) => {
        if (res.returnCode == 200 && res.data.length > 0) {
          this.typeList = res.data;
        }
      });
    },
    // 获取关于我们分类
    getAboutType() {
      aboutType(this.$store.getters.lang).then((res) => {
        if (res.returnCode == 200 && res.data.length > 0) {
          this.aboutList = res.data;
        }
      });
    },
    getList() {
      let data = {
        page: 0,
        // moduleType: 6,
        language: this.$store.getters.lang,
      };
      homePage(data).then((res) => {
        if (res.returnCode == 200 && res.data.length > 0) {
          res.data.forEach(item=>{
            if(item.moduleType==6){
              this.info = item
            }
            if(item.moduleType==12){
              this.erCodes=JSON.parse(item.mainDescription)
            }
          })
        }
        console.log('38483===kkdjfdfdf',this.erCodes)
      });
    },
    // 跳转页面
    goPage(type, item) {
      console.log("87273=dsds", item);
      switch (type) {
        case 1:
          this.$router.push({
            path: "/companyintroduction",
            query: {
              data: encodeURIComponent(JSON.stringify(item)),
            },
          });

          break;
        case 2:
          this.$router.push({
            path: "/service",
            query: {
              id: item.typeId,
            },
          });
          break;
        case 3:
          this.$router.push({
            path: "/products",
            query: {
              id: item.typeId,
            },
          });
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
/*** Footer ***/
.box_img {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.img_ {
  width: 80px;
  height: 80px;
}
.text {
  display:flex;
  justify-content:center;
  padding:8px 0;
  width: 100%;
}

.footer {
  background: url("../assets/hhdimg/footer.png") center center no-repeat;
  background-size: contain;
}

.footer .btn.btn-social {
  margin-right: 5px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(256, 256, 256, 0.1);
  border-radius: 40px;
  transition: 0.3s;
}

.footer .btn.btn-social:hover {
  color: var(--primary);
}

.footer .btn.btn-link {
  display: block;
  margin-bottom: 4px;
  padding: 0;
  text-align: left;
  color: rgba(255, 255, 255, 0.5);
  font-weight: normal;
  transition: 0.3s;
}

.footer .btn.btn-link:hover {
  color: #ffffff;
}

/* .footer .btn.btn-link::before {
    position: relative;
    content: "\f105";
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    margin-right: 10px;
} */

.footer .btn.btn-link:hover {
  letter-spacing: 1px;
  box-shadow: none;
}

.footer .copyright {
  padding: 25px 0;
  font-size: 14px;
  border-top: 1px solid rgba(256, 256, 256, 0.1);
}

.footer .copyright a {
  color: rgba(255, 255, 255, 0.5);
}

.footer .copyright a:hover {
  color: #ffffff;
}

.footer .footer-menu a {
  margin-right: 15px;
  padding-right: 15px;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.footer .footer-menu a:last-child {
  margin-right: 0;
  padding-right: 0;
  border-right: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue